// extracted by mini-css-extract-plugin
export default {"content":"style_content__dzW4o","map":"style_map__-3Ogr"};